import { useEffect, useState } from "react";
import styled from "styled-components";
import { APP_TITLE } from "../../../config/constant";
import { useOutletContext } from "react-router";
import SupportHeaderComponent from "./SupportHeaderComponent";
import QandAHeaderComponent from "./QandAHeaderComponent";
import GridComponent from "./GridComponent";
import NavigateBostageImage from "../../../assets/images/navigate-bostage.png";
import FrontSystemImage from "../../../assets/images/front-system.png";
import VirtualStoreImage from "../../../assets/images/virtual-store.png";
import VirtualStoreIDImage from "../../../assets/images/step-two.png";
import BOStoreImage from "../../../assets/images/step-three.png";
import FSStoreImage from "../../../assets/images/step-four.png";
import ShopifyImage from "../../../assets/images/shopify.png";
import TrazeImage from "../../../assets/images/traze.png";
import SitooImage from "../../../assets/images/sitoo.png";
import FullScreenOverlay from "../../common/overlay/FullScreenOverlay";
import FrontSystemPopup from "./FrontSystemPopup";
import GuidelinePopup from "./GuidelinePopup";

// Styled component for the support page
const StyledPage = styled.div`
    &.main-support-container {
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding-bottom: 50px;
    }
    .quick-q_a__container {
        display: flex;
        flex-direction: column;
        gap: 16px;
    }

    .frame-313348 {
        display: flex;
        flex-direction: row;
        gap: 32px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .line-2 {
        margin-top: -1px;
        border-style: solid;
        border-color: var(--backgrounds-and-lines-n-100, #3c485a);
        border-width: 1px 0 0 0;
        flex: 1;
        height: 0px;
        position: relative;
    }
    .still-need-help {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: center;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 28px;
        letter-spacing: -0.005em;
        font-weight: 400;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .line-1 {
        margin-top: -1px;
        border-style: solid;
        border-color: var(--backgrounds-and-lines-n-100, #3c485a);
        border-width: 1px 0 0 0;
        flex: 1;
        height: 0px;
        position: relative;
    }
    .call-to-action-container {
        display: grid;
        align-items: center;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        gap: 24px;
    }
`;

// #region TUTORIAL DATA
const tutorialData = [
    {
        title: "How to navigate BOstages",
        backgroundImg: NavigateBostageImage,
        style: { width: "392px", height: "220px" },
        isDisabled: false
    },
    {
        title: "How to handle BOimages",
        backgroundImg: null,
        style: { width: "392px", height: "220px" },
        isDisabled: true
    },
    {
        title: "How to handle Label Brands",
        backgroundImg: null,
        style: { width: "392px", height: "220px" },
        isDisabled: true
    },
    {
        title: "How to manage Fulfillment Centers",
        backgroundImg: null,
        style: { width: "392px", height: "220px" },
        isDisabled: true
    },
    {
        title: "How to handle Reorders",
        backgroundImg: null,
        style: { width: "392px", height: "220px" },
        isDisabled: true
    },
    {
        title: "How to share stock",
        backgroundImg: null,
        style: { width: "392px", height: "220px" },
        isDisabled: true
    },
    {
        title: "How to export product master data",
        backgroundImg: null,
        style: { width: "392px", height: "220px" },
        isDisabled: true
    },
    {
        title: "How to handle users",
        backgroundImg: null,
        style: { width: "392px", height: "220px" },
        isDisabled: true
    }
];

const integrationData = [
    {
        value: "frontsystems",
        title: "Integrate with Front Systems",
        backgroundImg: FrontSystemImage,
        style: { width: "auto", height: "86px" },
        isDisabled: false
    },
    {
        value: "shopify",
        title: "Integrate with Shopify",
        backgroundImg: ShopifyImage,
        style: { width: "auto", height: "86px" },
        isDisabled: true
    },
    {
        value: "traze",
        title: "Integrate with Traze",
        backgroundImg: TrazeImage,
        style: { width: "auto", height: "86px" },
        isDisabled: true
    },
    {
        value: "sitoo",
        title: "Integrate with Sitoo",
        backgroundImg: SitooImage,
        style: { width: "auto", height: "86px" },
        isDisabled: true
    }
];

const fsGuidelineData = [
    {
        title: "How To Integrate with Front Systems - STEP 1 - Ask for API keys and Virtual store ID",
        backgroundImg: VirtualStoreImage
    },
    {
        title: "How To Integrate with Front Systems - STEP 2 - Save API keys and Virtual store ID",
        backgroundImg: VirtualStoreIDImage
    },
    {
        title: "How To Integrate with Front Systems - STEP 3 - Connect each store to BOtag",
        backgroundImg: BOStoreImage
    },
    {
        title: "How To Integrate with Front Systems - STEP 4 - Connect each store to BOtag ",
        backgroundImg: FSStoreImage
    }
];
// #endregion

export default function Support() {
    document.title = `${APP_TITLE} - Support`; // Set the document title

    // #region VARS
    const { MainLayoutProps, layoutType } = useOutletContext();
    const props = {
        layoutType: layoutType,
        setControlBarLeftBtns: MainLayoutProps?.setControlBarLeftBtns,
        setControlBarCenterBtns: MainLayoutProps?.setControlBarCenterBtns,
        setControlBarRightBtns: MainLayoutProps?.setControlBarRightBtns,
        setFilterHeaderProperties: MainLayoutProps?.setFilterHeaderProperties,
        setRefreshUserData: MainLayoutProps?.setRefreshUserData
    };
    // #endregion

    // #region EFFECTS
    useEffect(() => {
        setupHeaders(props); // Setup headers when layoutType changes
    }, [props?.layoutType]);

    // #endregion

    const [tmpSearchQuery, setTmpSearchQuery] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [loading, setLoading] = useState(false);
    const [showResults, setShowResults] = useState(false);
    const [showResultDetails, setShowResultDetails] = useState(false);
    const [activeTab, setActiveTab] = useState("tutorials"); // Track active tab
    const [data, setData] = useState(tutorialData); // State to hold data
    const [showFrontSystemPopup, setShowFrontSystemPopup] = useState(false);
    const [showGuidelinePopup, setShowGuidelinePopup] = useState(false);

    // #region METHODS
    const handleSearch = () => {
        setShowResultDetails(false);
        if (tmpSearchQuery) {
            setShowResults(true);
            setLoading(true);
            setTimeout(() => {
                setSearchQuery(tmpSearchQuery);
                setLoading(false);
                // Implement search functionality here
            }, 3000);
        } else {
            setShowResults(false);
        }
    };
    const handleTab = tab => {
        setActiveTab(tab);
        // Update data based on tab
        if (tab === "tutorials") {
            setData(tutorialData);
        } else if (tab === "integrations") {
            setData(integrationData);
        } else {
            setData([]); // For disabled/empty tabs
        }
    };
    const handleAction = value => {
        if (value === "frontsystems") {
            // Show Front System Popup
            setShowFrontSystemPopup(true);
        } else {
            // Handle other actions
            console.log("Action triggered for:", value);
        }
    };

    const closePopup = () => {
        setShowFrontSystemPopup(false);
    };

    const handleGuidelineAction = () => {
        // Show Guideline Popup
        setShowGuidelinePopup(true);
        closePopup();
    };

    const closeGuidelinePopup = () => {
        setShowGuidelinePopup(false);
    };
    //#endregion

    return (
        <StyledPage className="main-support-container">
            <FullScreenOverlay show={showFrontSystemPopup}>
                <FrontSystemPopup closePopup={closePopup} handleGuidelineAction={handleGuidelineAction} />
            </FullScreenOverlay>
            <FullScreenOverlay show={showGuidelinePopup}>
                <GuidelinePopup data={fsGuidelineData} closeGuidelinePopup={closeGuidelinePopup} />
            </FullScreenOverlay>
            <SupportHeaderComponent
                tmpSearchQuery={tmpSearchQuery}
                setTmpSearchQuery={setTmpSearchQuery}
                onSearch={handleSearch}
                showResults={showResults}
                showResultDetails={showResultDetails}
            />
            <div className="quick-q_a__container">
                <QandAHeaderComponent handleTab={handleTab} activeTab={activeTab} />
                <GridComponent data={data} handleAction={handleAction} />
            </div>
        </StyledPage>
    );
}

/* #region Set Header CTA */
function setupHeaders(props, updateData) {
    props.setControlBarLeftBtns([]); // Clear left buttons
    props.setControlBarCenterBtns([{ to: "#", active: true, disabled: false, title: "SUPPORT" }]); // Set center button
    props.setControlBarRightBtns([]); // Clear right buttons

    props.setFilterHeaderProperties({
        customContentHeader: ""
    });
}
/* endregion */
